import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceEmailDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { ColorLabel } from '../../components/ColorLabel.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { cssAspectRatio } from '../sharedCss.js';
import { getResourceNamePlaceholder } from '../../../../utils/getResourceTitle.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import Divider from '@fabric-app/ui/components/Divider';
import { ResourceGridViewLoadingIndicator } from '../components/ResourceGridViewLoadingIndicator.js';
import { IconCard30pxKindEmail } from '@fabric-app/icons/svg';
import { Flex } from '@fabric-app/ui/components/Flex';
import { SPAN } from '@fabric-app/ui/components/Typography';
import EditorPreview from '../../../EditorPreview/EditorPreview.js';
import { getIntegrationConfig } from '../../../../../connections/connections.config.js';

const ResourcePreviewEmail = () => {
  const { resource } = useResourceEmailDataContextSafe();
  const providerConfig = resource._meta?.externalData?.provider ? getIntegrationConfig(resource._meta?.externalData?.provider) : null;
  return /* @__PURE__ */ jsxs(Wrapper, {
    "data-preview-content-wrapper": "email",
    children: [
      /* @__PURE__ */ jsx(ColorLabel, {
        absPosition: "inside-top-left"
      }),
      /* @__PURE__ */ jsx(ResourceGridViewLoadingIndicator, {
        resource
      }),
      /* @__PURE__ */ jsxs(Flex, {
        alignItems: "center",
        gap: "element",
        overflow: "hidden",
        flexShrink: 0,
        style: {
          color: cssVar["color-text-tertiary"]
        },
        children: [
          providerConfig && providerConfig.IconCardPreview ? /* @__PURE__ */ jsx(providerConfig.IconCardPreview, {}) : /* @__PURE__ */ jsx(StyledIconCard30pxKindEmail, {}),
          /* @__PURE__ */ jsx(SPAN, {
            ellipsis: true,
            color: "tertiary",
            weight: 600,
            size: "sm",
            children: resource.data.emailMessage?.from || "Unknown sender"
          })
        ]
      }),
      /* @__PURE__ */ jsx(Title, {
        children: resource.name || /* @__PURE__ */ jsx(TitlePlaceholder, {
          children: getResourceNamePlaceholder(resource)
        })
      }),
      /* @__PURE__ */ jsx(StyledDivider, {
        borderColor: "tertiary"
      }),
      resource.data.emailPreview?.html && /* @__PURE__ */ jsx(StyledEditorPreview, {
        withTruncator: true,
        data: {
          content: resource.data.emailPreview.html
        }
      })
    ]
  });
};
const StyledDivider = styled(Divider).withConfig({
  displayName: "ResourcePreviewEmail__StyledDivider",
  componentId: "sc-9becbe7d-0"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const TitlePlaceholder = styled.span.withConfig({
  displayName: "ResourcePreviewEmail__TitlePlaceholder",
  componentId: "sc-9becbe7d-1"
})([
  `opacity:0.5;`
]);
const StyledIconCard30pxKindEmail = styled(IconCard30pxKindEmail).withConfig({
  displayName: "ResourcePreviewEmail__StyledIconCard30pxKindEmail",
  componentId: "sc-9becbe7d-2"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewEmail__Wrapper",
  componentId: "sc-9becbe7d-3"
})([
  `width:100%;height:100%;display:flex;flex-direction:column;flex-grow:1;gap:0.75rem;overflow:hidden;padding:0.75rem;border-radius:var(--preview-content-border-radius,1.125rem);position:relative;border:var(--preview-border-width,2px) solid var(--preview-border-color,`,
  `);background:`,
  `;`,
  `;`,
  `{border:none;border-radius:0;padding:0.75rem;gap:0.625rem;}`
], cssVar["color-border-secondary"], cssVar["color-bg-primary"], cssAspectRatio, containerPreviewCompact);
const Title = styled.div.withConfig({
  displayName: "ResourcePreviewEmail__Title",
  componentId: "sc-9becbe7d-4"
})([
  `font-weight:500;font-size:0.875rem;line-height:1.25rem;color:rgba(`,
  `,0.8);`
], cssVar["color-text-tertiary-rgb"]);
const StyledEditorPreview = styled(EditorPreview).withConfig({
  displayName: "ResourcePreviewEmail__StyledEditorPreview",
  componentId: "sc-9becbe7d-5"
})([
  `font-size:13px;line-height:1.5;color:`,
  `;flex-grow:1;`,
  `{font-size:0.75rem;font-weight:500;}`
], cssVar["color-text-tertiary"], containerPreviewCompact);

export { ResourcePreviewEmail, TitlePlaceholder };
//# sourceMappingURL=ResourcePreviewEmail.js.map
